import { autoserialize } from 'cerialize';

export class Sector {
  @autoserialize id!: string;
  @autoserialize name!: string;
  @autoserialize organization!: string;
}
